import { render, staticRenderFns } from "./RibbonsCreateEdit.vue?vue&type=template&id=5085bc44"
import script from "./RibbonsCreateEdit.vue?vue&type=script&lang=js"
export * from "./RibbonsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports